import EchartsReactCore from './core';
//import echarts from 'echarts';
//import echarts from '../../ECharts/echarts';
let echarts = require("../../ECharts/echarts");

require("../../ECharts/component/dataset");

require("../../ECharts/chart/line");

require("../../ECharts/chart/bar");

require("../../ECharts/chart/pie");

require("../../ECharts/chart/scatter");

require("../../ECharts/chart/radar");

require("../../ECharts/chart/map");

require("../../ECharts/chart/tree");

require("../../ECharts/chart/treemap");

require("../../ECharts/chart/graph");

require("../../ECharts/chart/gauge");

require("../../ECharts/chart/funnel");

require("../../ECharts/chart/parallel");

require("../../ECharts/chart/sankey");

require("../../ECharts/chart/boxplot");

require("../../ECharts/chart/candlestick");

require("../../ECharts/chart/effectScatter");

require("../../ECharts/chart/lines");

require("../../ECharts/chart/heatmap");

require("../../ECharts/chart/pictorialBar");

require("../../ECharts/chart/themeRiver");

require("../../ECharts/chart/sunburst");

require("../../ECharts/chart/custom");

require("../../ECharts/component/graphic");

require("../../ECharts/component/grid");

require("../../ECharts/component/legendScroll");

require("../../ECharts/component/tooltip");

require("../../ECharts/component/axisPointer");

require("../../ECharts/component/polar");

require("../../ECharts/component/geo");

require("../../ECharts/component/parallel");

require("../../ECharts/component/singleAxis");

require("../../ECharts/component/brush");

require("../../ECharts/component/calendar");

require("../../ECharts/component/title");

require("../../ECharts/component/dataZoom");

require("../../ECharts/component/visualMap");

require("../../ECharts/component/markPoint");

require("../../ECharts/component/markLine");

require("../../ECharts/component/markArea");

require("../../ECharts/component/timeline");

require("../../ECharts/component/toolbox");

require("zrender/src/vml/vml");

require("zrender/src/svg/svg");

// export the Component the echarts Object.
export default class EchartsReact extends EchartsReactCore {
  constructor(props) {
    super(props);
    this.echartsLib = echarts;
  }
}
